import { AssetCatalogueService } from './services/asset-catalogue-service';
import { GameListenerService } from './services/game-listener-service';
import { GameMetricsService } from './services/game-metrics-service';
import { GameRunnerService } from './services/game-runner-service';
import { SolitaireListener } from './solitaire-listener';

export class GameServices {
  public readonly assetCatalogueService: AssetCatalogueService;
  public readonly gameMetricsService: GameMetricsService;
  public readonly gameListenerService: GameListenerService;
  public readonly gameRunnerService: GameRunnerService;
  public readonly usingLocalDealer: boolean;

  constructor() {
    this.assetCatalogueService = new AssetCatalogueService();

    this.gameMetricsService = new GameMetricsService();
    this.gameListenerService = new GameListenerService();
    this.gameRunnerService = new GameRunnerService(this.gameListenerService);

    // This is a way to enable local dealer
    this.usingLocalDealer = false;
  }

  public setSolitaireListener(solitaireListener: SolitaireListener) {
    this.gameListenerService.setSolitaireListener(solitaireListener);
  }
}
